import React from 'react';
import { Card } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const RevenueCharts = ({ propertyRevenues = [], totalConcierge = 0, hideAppRevenue = false }) => {
  const barChartData = propertyRevenues.slice(0, 5).map(item => ({
    name: item.property_name.length > 15 ? item.property_name.substring(0, 15) + '...' : item.property_name,
    revenue: item.revenue
  }));

  return (
    <div className={hideAppRevenue ? "" : "grid grid-cols-1 lg:grid-cols-2 gap-6"}>
      {/* Bar Chart - Revenus par logement */}
      <Card className="bg-white border border-slate-100 shadow-sm rounded-xl p-6">
        <h3 className="text-xl font-medium text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Top 5 Logements
        </h3>
        {barChartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={barChartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="name" tick={{ fill: '#64748b', fontSize: 12 }} />
              <YAxis tick={{ fill: '#64748b', fontSize: 12 }} />
              <Tooltip 
                contentStyle={{ backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '8px' }}
                formatter={(value) => `${value.toFixed(2)} €`}
              />
              <Bar dataKey="revenue" fill="#E11D48" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-slate-500 text-sm">
            Aucune donnée disponible
          </div>
        )}
      </Card>
    </div>
  );
};

export default RevenueCharts;
